import { RootState } from '../store'

export const languageSelector = (state: RootState) => state.language.language
